import { css } from 'styled-components';
export const focusVisibleAlt = () => css `
  &:focus-visible {
    ${({ theme: { FOCUS_STYLES_ALT } }) => FOCUS_STYLES_ALT}
  }
`;
//# sourceMappingURL=focusAlt.mixin.js.map